import axios from 'axios';
const apiClient = axios.create({
    baseURL: envConfig.OUTBOUND_SEARCH_URL,
    withCredentials: true,
});
export default apiClient;
